export default __webpack_public_path__ + "static/media/completed.797e2d54.jfif";